module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0655.ce049ba0.jpg";